var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "ef-row", class: { focused: _vm.focused } },
    [
      _c(
        "span",
        { staticClass: "ef-grip handle" },
        [_c("w-fa", { attrs: { icon: "grip-vertical" } })],
        1
      ),
      _c("span", { staticClass: "ef-key", class: _vm.type.toLowerCase() }, [
        _vm._v(_vm._s(_vm.keyLabel)),
      ]),
      _c("input", {
        ref: "name",
        staticClass: "ef-name",
        attrs: { placeholder: _vm.$ct("field-name-placeholder") },
        domProps: { value: _vm.name },
        on: {
          input: function ($event) {
            return _vm.onName($event.target.value)
          },
          focus: function ($event) {
            _vm.focused = true
          },
          blur: function ($event) {
            _vm.focused = false
          },
          keydown: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            $event.preventDefault()
            return _vm.$emit("enter")
          },
        },
      }),
      _c(
        "span",
        { staticClass: "ef-opts", attrs: { title: _vm.summaryTitle } },
        [
          _vm._l(_vm.summary, function (part, i) {
            return [
              i > 0
                ? _c("i", { key: "dot" + i, staticClass: "ef-dot" })
                : _vm._e(),
              _c("span", { key: "p" + i, class: { warn: part.warn } }, [
                _vm._v(_vm._s(part.text)),
              ]),
            ]
          }),
        ],
        2
      ),
      _c(
        "button",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: _vm.$ct("field-options"),
              expression: "$ct('field-options')",
            },
          ],
          staticClass: "ef-ib",
          attrs: { type: "button", disabled: !_vm.name },
          on: {
            click: function ($event) {
              _vm.modalOpen = true
            },
          },
        },
        [_c("w-fa", { attrs: { icon: "cog" } })],
        1
      ),
      _c(
        "button",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: _vm.$ct("clear-field"),
              expression: "$ct('clear-field')",
            },
          ],
          staticClass: "ef-ib del",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("clear")
            },
          },
        },
        [_c("w-fa", { attrs: { icon: "trash" } })],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.modalOpen } },
        [
          _vm.modalOpen
            ? _c(_vm.optionsComponent, {
                tag: "component",
                attrs: {
                  value: _vm.config,
                  "options-index": _vm.index,
                  "extra-fields-type": _vm.extraFieldsType,
                },
                on: {
                  close: function ($event) {
                    _vm.modalOpen = false
                  },
                  input: function ($event) {
                    return _vm.onOptions($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }